module.exports = __webpack_public_path__ + "files/2803cca030f6ac43862b796237fc1198.png";